<dx-popup [showTitle]="true" title="Nuovo allegato per {{dipendente.codice}} {{dipendente.nominativo}}" [dragEnabled]="false" selectionMode="none" [hideOnOutsideClick]="false"
  [showCloseButton]="true" container=".dx-viewport" visible="true" (onHiding)="onEsciClick()" height="50vh">
  <div class="row">
    <div class="col-lg-4 col-md-6 col-sm-8 col-12 offset-lg-8 offset-md-6 offset-sm-4">
      <dx-button stylingMode="contained" text="CONFERMA" icon="save" type="success" (onClick)="allegaFile($event, fileUploader.value)" style="width: 150px; margin-right: 10px;">
      </dx-button>
      <dx-button stylingMode="contained" text="ESCI" icon="close" type="danger" (onClick)="onEsciClick()" style="width: 100px;">
      </dx-button>
    </div>
  </div>
  <form>
    <div class="row">
      <div class="col-6 col-md-4">
        <div class="dx-fieldset-header">Nome allegato</div>
        <dx-text-box [(value)]="nomeAllegato">
          <dx-validator>
            <dxi-validation-rule type="required" message="Inserire il nome"></dxi-validation-rule>
          </dx-validator>
        </dx-text-box>

      </div>
    </div>
    <div class="row">
      <div class="col-6 col-md-4">
        <div class="widget-container">
          <div class="dx-fieldset-header">File </div>
          <dx-file-uploader
            #fileUploader

            [multiple]="false"
            accept="*"
            [(value)]="value"
            uploadMode="useForm"
            >
            <dx-validator>
              <dxi-validation-rule type="required" message="Selezionare il file"></dxi-validation-rule>
            </dx-validator>
          </dx-file-uploader>
          <div class="content">
            @if (value.length > 0) {
              <div>
                <h4>Selected Files</h4>
              </div>
            }
            @for (file of value; track file) {
              <div>
                <div class="selected-item">
                  Name:
                  <span>{{file.name}}</span><br /> Size:
                  <span>{{file.size}}</span>bytes<br /> Type:
                  <span>{{file.type}}</span><br /> Last Modified Date:
                  <span>{{file.lastModifiedDate}}</span>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>

  </form>


</dx-popup>

<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)"
  [(visible)]="loadPanelVisible"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  [hideOnOutsideClick]="false">
</dx-load-panel>